var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{ref:"ptvModel",attrs:{"modalNode":_vm.modalNode,"title":"PTV","id":"ptvModel","close":_vm.close}},[_c('template',{slot:"head"},[_c('div',{staticClass:"head-operate"})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }